// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1CZ4i","buttons":"SendReceipts_buttons__3C6tT","email":"SendReceipts_email__OMOgC","bookApptTitle":"SendReceipts_bookApptTitle__j3O54"};